import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['published_at', 'deleted_at', 'created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                course_type_id: null,
                course_type: null,
                title: null,
                description: null,
                basic_description: null,
                is_active: null,
                enrollment_capacity: null,
                published_at: null,
                has_gradable_activity: null,
                deleted_at: null,
                created_at: null,
                updated_at: null,
                tags: [],
                groups: [],
                course_codes: null,
                archived_at: null,

                order: null,
            };
        },

        getters: {},

        actions: {
            /**
             * @param context
             * @param payload
             * @returns {Promise<any>}
             */
            put(context, payload) {
                return new Promise((resolve, reject) => {
                    window.axios
                        .put(`/api/course-templates/${context.state.id}`, payload)
                        .then(response => {
                            context.dispatch('CourseTemplates/add', response.data.data, {
                                root: true,
                            });

                            resolve(response);
                        })
                        .catch(error => {
                            context.dispatch(
                                'Alerts/add',
                                {
                                    key: 'course_template_saving_error',
                                    title: 'An Error Has Occurred',
                                    message: 'This course template has failed to save',
                                    type: 'danger',
                                },
                                { root: true }
                            );

                            reject(error);
                        });
                });
            },
        },

        mutations: {},
    }
);
